import { readonly } from "vue";

export function useLoading(defaultState = true) {
  const inProgress = ref<boolean>(defaultState);

  const start = async () => (inProgress.value = true);
  const stop = () => (inProgress.value = false);

  return {
    inProgress: readonly(inProgress),
    start,
    stop,
  };
}
